import React from "react"
import "../css/cta-row.css"
import OnVisible from "react-on-visible"

import Img from "gatsby-image"
import { Link } from "gatsby"

import { HandleImages } from "../components/functions"

class CTARow extends React.Component {
  constructor(props) {
    super(props)
  }

  handleClasses() {
    var temp = "cta-row-wrapper"
    this.props.inv && (temp += " inv")

    if (this.props.bgColor == "yellow") {
      temp += " yellow"
    } else if (this.props.bgColor == "deep-blue") {
      temp += " deep-blue"
    } else if (this.props.bgColor == "bright-blue") {
      temp += " bright-blue"
    }

    return temp
  }

  render() {
    return (
      <OnVisible
        className={this.handleClasses()}
        id={this.props.image === "phone" ? "phone-wrapper" : ""}
      >
        <div>
          <div>
            <h3>{this.props.title ? this.props.title : "props.title"}</h3>
            <p>{this.props.text ? this.props.text : "props.text"}</p>
            {this.props.url &&
              (this.props.url.charAt(0) == "/" ? (
                <Link to={this.props.url}>
                  <button name={this.props.cta} className="outlined-button">
                    {this.props.cta}
                  </button>
                </Link>
              ) : (
                <a href={this.props.url}>
                  <button name={this.props.cta} className="outlined-button">
                    {this.props.cta}
                  </button>
                </a>
              ))}
<div className="buttons">

  {this.props.calendly}
            {this.props.click && (
              <button
                name={this.props.cta}
                onClick={this.props.click}
                className="outlined-button"
              >
                {this.props.cta}
              </button>
            )}</div>
          </div>
        </div>
        <div >
          {this.props.image === "laptop" ? (
            <HandleImages name="laptop" />
          ) : this.props.image === "document" ? (
            <HandleImages name="document" />
          ) : this.props.image === "laptopF" ? (
            <HandleImages name="laptopF" />
          ) : (
            <div className="phone">
              {" "}
              <HandleImages name="phone" />
            </div>
          )}
        </div>
      </OnVisible>
    )
  }
}

export default CTARow
